import React, { useEffect, useState } from 'react';
import HeaderPublic from './HeaderPublic';
import { Col, Container, Row } from 'react-bootstrap';
import { firestore } from '../Firebase';
import { Link } from 'react-router-dom';

const VideoThumbnail = React.memo(({ video }) => (
  <Link to={`/stream/${video.id}`} style={{ textDecoration: 'none' }}>
    <img
      src={video.thumbnail}
      alt={video.title || 'Video thumbnail'}
      style={{ width: '100%', height: 'auto' }}
    />
    <p style={{ 
      color: 'black', 
      fontSize: '1.25rem', 
      fontWeight: 'bold', 
      marginTop: '8px', 
      lineHeight: '1.2' 
    }}>
      {video.title || 'Untitled Video'}
    </p>
  </Link>
));

const PageThumbnail = React.memo(({ page }) => (
  <Link to={`/page/${page.id}`} style={{ textDecoration: 'none' }}>
    <div className="bg-white rounded overflow-hidden shadow-sm h-100">
      {page.thumbnail ? (
        <img
          src={page.thumbnail}
          alt={page.title || 'Page thumbnail'}
          style={{ width: '100%', height: 'auto', aspectRatio: '16/9', objectFit: 'cover' }}
        />
      ) : (
        <div 
          className="d-flex align-items-center justify-content-center bg-light text-muted"
          style={{ width: '100%', aspectRatio: '16/9' }}
        >
          <i className="fas fa-file-alt fa-3x"></i>
        </div>
      )}
      <div className="p-3">
        <p style={{ 
          color: 'black', 
          fontSize: '1.25rem', 
          fontWeight: 'bold', 
          margin: 0, 
          lineHeight: '1.2' 
        }}>
          {page.title || 'Untitled Page'}
        </p>
      </div>
    </div>
  </Link>
));

const Lobby = () => {
  const [videos, setVideos] = useState([]);
  const [pages, setPages] = useState([]);
  const [features, setFeatures] = useState({
    hasDarkModeOn: false,
  });
  const [customization, setCustomization] = useState({});

  useEffect(() => {
    fetchVideos();
    fetchPages();

    // Listen for feature changes
    const unsubscribeFeatures = firestore
      .collection('settings')
      .doc('features')
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            setFeatures({
              hasDarkModeOn: data.hasDarkModeOn || false,
            });
          }
        },
        (error) => {
          console.error('Error listening to features changes:', error);
        }
      );

    // Listen for customization changes
    const unsubscribeCustomization = firestore
      .collection('settings')
      .doc('customization')
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            setCustomization(doc.data());
          }
        },
        (error) => {
          console.error('Error listening to customization changes:', error);
        }
      );

    return () => {
      unsubscribeFeatures();
      unsubscribeCustomization();
    };
  }, []);

  const fetchPages = () => {
    firestore.collection('pages').onSnapshot((snapshot) => {
      const pageData = [];
      snapshot.forEach((doc) => {
        pageData.push({ id: doc.id, ...doc.data() });
      });
      setPages(pageData);
    });
  };

  const fetchVideos = () => {
    firestore.collection('videos').onSnapshot((snapshot) => {
      const videoData = [];
      snapshot.forEach((doc) => {
        videoData.push({ id: doc.id, ...doc.data() });
      });
      setVideos(videoData);
    });
  };

  return (
    <Container fluid>
      <Row>
        <HeaderPublic features={features} />
      </Row>
      <Row>
        <Col>
          <h2 className="mt-4 mb-3 text-white text-center">{customization.subtitle}</h2>
          
          {pages.length > 0 && (
            <>
              <Row className="mb-4">
                {pages.map((page) => (
                  <Col key={page.id} xs={12} sm={6} md={4} className="mb-4">
                    <PageThumbnail page={page} />
                  </Col>
                ))}
              </Row>
              <hr className="my-5" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
            </>
          )}

          <Row>
            {videos.map((video) => (
              <Col key={video.id} xs={12} sm={6} md={4} className="mb-4">
                <VideoThumbnail video={video} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Lobby;
